import { FC } from 'react'

const wineColors = {
  red: 1,
  white: 2,
  rose: 3,
  orange: 4,
}
const wineTypes = {
  others: 1,
  sparkling: 2,
  fortified: 3,
  semiSparkling: 4,
}

const colors = {
  [wineColors.red]: '#88122B',
  [wineColors.rose]: '#FFC1CD',
  [wineColors.white]: '#FFD99F',
  [wineColors.orange]: '#FBA11E',
}

interface GlassProps {
  type: number | undefined
  color: number | undefined
  size?: 'big' | 'small'
}

const Glass: FC<GlassProps> = props => {
  let { type, color, size } = props

  if (!color || !Object.values(wineColors).includes(color))
    color = wineColors.white
  const wineColor = colors[color]

  let icon
  if (type === wineTypes.sparkling) icon = sparkling
  else if (type === wineTypes.fortified) icon = fortified
  else icon = others

  const width = size === 'big' ? 48 : 24
  const height = size === 'big' ? 80 : 36

  return icon(wineColor, width, height)
}

// prettier-ignore
const sparkling = (color, width, height) => (
  <svg width={width} height={height} viewBox='0 0 24 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M8.5 12c.47-.5 1.45-1 2-1 .59 0 1.36.27 1.83.78v0c.83.88 2.68.8 3.06-.36.04-.12.08-.26.11-.42'
          stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='m8 14.5.5-3L11 11l2 1.5h1.5l1-1 .5 3-1 4-1.5 2h-3l-1.5-2-1-2v-2Z' fill={color} />
    <path d='M8 33h8m-4-12v12m3.33-29 .67 9.92c0 4.26-1.8 7.08-4 7.08s-4-2.82-4-7.08L8.67 4h6.66Z' stroke='#121432'
          strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

// prettier-ignore
const fortified = (color, width, height) => (
  <svg width={width} height={height} viewBox='0 0 24 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M8.5 19c.47-.5 1.45-1 2-1 .59 0 1.36.27 1.83.78v0c.83.88 2.68.8 3.06-.36.04-.12.08-.26.11-.42'
          stroke={color} strokeLinecap='round' strokeLinejoin='round' />
    <path d='M8 18.5h.5L11 18l2 1.5h1.5l1-1h.5l-.5 4.5-2 1.5h-3l-2-1.5-.5-2.5v-2Z' fill={color} />
    <path d='M8 33h8m-4-8v8m3.33-21 .67 7.92C16 23 14.2 25 12 25s-4-2-4-5.08L8.67 12h6.66Z' stroke='#121432'
          strokeLinecap='round' strokeLinejoin='round' />
  </svg>
)

// prettier-ignore
const others = (color, width, height) => (
  <svg width={width} height={height} viewBox='0 0 24 36' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M7 14c.72-.65 1.6-1 2.5-1 .9 0 1.78.35 2.5 1s1.6 1 2.5 1c.9 0 1.78-.35 2.5-1' stroke={color}
          strokeLinecap='round' strokeLinejoin='round' />
    <path d='M7.5 14 9 13l4 1.5 2 .5 2.5-1 .5 2.5-2 3-2.5 1h-3L8 20l-1.5-2-.5-2 .5-1.5 1-.5Z' fill={color} />
    <path d='M8 33h8m-4-12v12m5-24 1 7c0 3.01-2.69 5-6 5s-6-1.99-6-5l1-7h10Z' stroke='#121432' strokeLinecap='round'
          strokeLinejoin='round' />
  </svg>
)

export default Glass
